export const INPUT_UNSET_VALUE = 'UNSET';

export const FACTOR_INFLUENCE_INFO_ITEM_MODAL_BUTTON_TYPE = {
    DETAIL: 'detail',
    PRIMARY: 'primary',
    LINK_DATE: 'link_date',
} as const;

export const FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_KEYS = {
    MAIN: 'main',
    ADDITIONAL: 'additional',
    FACTORS: 'factors',
} as const;

export const FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_NAMES = {
    MAIN: 'Основная информация',
    ADDITIONAL: 'Дополнительные поля',
    FACTORS: 'Информация о факторах и товарах',
} as const;

/** Поля формы, относящиеся к вкладке "Дополнительные поля" */
export const ADDITIONAL_FIELDS_TAB_FIELD_NAMES = [
    'suppliesDifficultId',
    'equipmentDifficultId',
    'maintenanceDifficultId',
    'priceId',
    'pricePercent',
    'costImportId',
    'costImportPercent',
    'costLogisticId',
    'costLogisticPercent',
    'prodVolumeId',
    'prodVolumePercent',
    'financCostId',
    'financCostPercent',
    'staffId',
    'staffPercent',
    'wageFundId',
    'wageFundPercent',
    'homeRevenueId',
    'homeRevenuePercent',
    'foreignRevenueId',
    'foreignRevenuePercent',
    'creditorDebtId',
    'creditorDebtPercent',
    'debtorDebtId',
    'debtorDebtPercent',
] as const;

export const CHANGES_LOOKUP_URL = '/ais/valueLists/FLEX_VALUE?sublistCode=changes';
export const YES_NO_LOOKUP_URL = '/ais/valueLists/FLEX_VALUE?sublistCode=yes_no';
export const EFFECT_INFLUENCE_LOOKUP_URL = '/ais/valueLists/FLEX_VALUE?sublistCode=effect_influence';
export const FACTOR_LEVEL_LOOKUP_URL = '/ais/valueLists/FLEX_VALUE?sublistCode=factor_level';
export const FACTOR_TYPE_CODE_LOOKUP_URL = '/ais/valueLists/FLEX_VALUE?sublistCode=factor_type_code';

/** Код lookup для "Изменения" */
export const IS_NOT_CHANGED_LOOKUP_CODE = '0';
/** Код lookup для "Уровень принятия санкций (компания)" */
export const COMPANY_LEVEL_LOOKUP_CODE = '3';
/** Код lookup для "Вид фактора (выход из международных проектов)" */
export const FACTOR_TYPE_CODE_TEN_LOOKUP_CODE = '10';
/** Код lookup для "Никак не повлияли (Повлияли ли макроэкономические факторы на вашу компанию?)" */
export const IS_NOT_AFFECT_LOOKUP_CODE = '0';

/** Сообщение об ошибке при отсутствии заполненных факторов */
export const FACTORS_REQUIRED_ERROR_MESSAGE = 'Не введена информация о факторах';

/** Код lookup для "Вид фактора (Запрет на экспорт в РФ)" */
export const FACTOR_TYPE_CODE_EXPORT_BAN_LOOKUP_CODE = '1';
/** Код lookup для "Вид фактора (Запрет на импорт из РФ)" */
export const FACTOR_TYPE_CODE_IMPORT_BAN_LOOKUP_CODE = '2';
/** Код lookup для "Вид фактора (Торговые ограничения)" */
export const FACTOR_TYPE_CODE_TRADE_RESTRICTIONS_LOOKUP_CODE = '8';

/** Сообщение об ошибке при отсутствии товаров */
export const PRODUCTS_REQUIRED_ERROR_MESSAGE = 'Необходимо добавить хотя бы один товар';